<template>
  <div>
    <page-header>
      <template v-slot:title>
        <div>
          Agenda de eventos 📅
        </div>
      </template>
    </page-header>
    <v-row justify="end" class="mr-4" v-if="false">
      <v-btn color="white" depressed rounded class="mx-2" @click="$router.push({name: 'NewEvent'})"> 
        <v-icon class="mr-1" size="26" color="primary">mdi-plus-circle-outline</v-icon> 
        NOVO LANÇAMENTO
      </v-btn>
    </v-row>
    <v-row>
      <v-col cols="12" lg="7">
        <next-events v-if="which_list == 'next-events'" is_component_used_in_all_events @changeCalendar="changeCalendar()" class="mt-n5" @selectedEvent="handleSelectedEvent"></next-events>
        <events-calendar v-if="which_list == 'events-calendar'" is_component_used_in_all_events :use_with_emit="true" @selectedEvent="handleSelectedEvent" @changeCalendar="changeCalendar()"></events-calendar>
      </v-col>
      <v-col cols="12" lg="5">
        <!-- <v-card outlined style='border-radius: 5px;'>
          <v-card-text v-if="Object.keys(this.event_item).length != 0" class="pa-0" >
            <selected-event-card :selected_event="event_item"  @closeDialog="handleClose"></selected-event-card>
          </v-card-text>
          <v-card-text v-if="!Object.keys(this.event_item).length != 0" >
            <div class="grey--text title pa-3">
              Selecione ao lado um evento para exibir.
            </div>
          </v-card-text>
        </v-card> -->
        <selected-event-card v-if="which_activity_list == 'selected_event'" :selected_event="event_item" @closeDialog="handleClose" short_description>
          <template v-slot:extra>
            <div>
              <v-btn
                icon
                color="primary"
                @click="changeList()"
              >
                <v-icon>mdi-format-list-bulleted</v-icon>
              </v-btn>
            </div>
          </template>
        </selected-event-card>
        <event-activities v-if="which_activity_list == 'activities'" is_component_show_all_company_activities>
          <template v-slot:extra>
            <div>
              <v-btn
                icon
                color="primary"
                @click="changeList()"
              >
                <v-icon>mdi-text-box-search-outline</v-icon>
              </v-btn>
            </div>
          </template>
        </event-activities>
      </v-col>
    </v-row>
  </div>
</template>

<script>
  import { mapState, mapActions, mapGetters } from 'vuex';

  export default {
    name: 'EventsAgenda',

    components: {
      NextEvents: () => import('./next_events/NextEvents.vue'),
      EventsCalendar: () => import('./calendar/EventsCalendar.vue'),
      SelectedEventCard: () => import('./calendar/SelectedEventCard.vue'),
      EventActivities: () => import('./register_forms/FormEventActivities.vue'),
    },
    
    data() {
      return {
        which_list: '',
        which_activity_list: '',
        event_item: {},
        selected_dialog: false,
      }
    },
    
    methods: {
      changeList(){
        if(this.which_activity_list == 'selected_event'){
          this.which_activity_list = 'activities'
          localStorage.which_activity_list = this.which_activity_list;
        }else{
          this.which_activity_list = 'selected_event'
          localStorage.which_activity_list = this.which_activity_list;
        }
      },
      changeCalendar(){
        if(this.which_list == 'events-calendar'){
          this.which_list = 'next-events'
          localStorage.which_list = this.which_list;
        }else{
          this.which_list = 'events-calendar'
          localStorage.which_list = this.which_list;
        }
      },
      getWhichList(){
        localStorage.which_activity_list ? this.which_activity_list = localStorage.which_activity_list : this.which_activity_list = 'selected_event'
        localStorage.which_list ? this.which_list = localStorage.which_list : this.which_list = 'events-calendar'
      },
      handleSelectedEvent(e) {
        this.event_item = e
        this.which_activity_list = 'selected_event'
        localStorage.which_activity_list = this.which_activity_list;
        if(e.scroll){
          setTimeout(() => {
            window.scrollTo({ left: 0, top: document.body.scrollHeight, behavior: "smooth" });
          }, 200);
        }

      },
      handleClose(){
        window.scrollTo({ left: 0, top: 0, behavior: "smooth" });
        setTimeout(() => {
          this.event_item = {}
        }, 400);
      },
    },
    mounted() {
      this.getWhichList()
    },
    watch: {
      activeCompanyId(){
        this.event_item = {}
      }
    },
    computed: {
      ...mapState({
        activeCompanyId: state => state.App.activeCompanyId
      }),
    },

  }
</script>

<style lang="scss" scoped>

</style>